import { MockHttpClient } from '../http/mock-http-client';
import { Repositories } from '../models/repositories';
import { Services } from '../models/services';
import { HttpCompanyKeyRepository } from '../repositories/company-key/http-company-key-repository';
import { HttpDeviceGroupPolicyVaultRepository } from '../repositories/device-group-policy-vault/http-device-group-policy-vault-repository';
import { HttpDeviceGroupVaultRepository } from '../repositories/device-group-vault/http-device-group-vault-repository';
import { HttpDeviceVaultRepository } from '../repositories/device-vault/http-device-vault-repository';
import { HttpVaultRepository } from '../repositories/http-vault-repository';
import { HttpVaultRequestRepository } from '../repositories/http-vault-request-repository';
import { HttpUserKeyRepository } from '../repositories/user-key/http-user-key-repository';
import { CompanyKeyService } from './company-key-service';
import { CryptoService } from './crypto-service';
import { DeviceGroupPolicyService } from './device-group-policy-service';
import { DeviceGroupService } from './device-group-service';
import { DeviceService } from './device-service';
import { HttpTokenService } from './http-token-service';
import { InitializeService } from './initialize-service';
import { KeyService } from './key-service';
import { KeyVaultService } from './key-vault-service';
import { StatefulUserKeyPromptService } from './stateful-user-key-prompt-service';
import { UserKeyPromptService } from './user-key-prompt-service';
import { WindowLocalStorage } from './window-local-storage';
export class ServiceFactory {
    constructor(uiFrameAdapter, http, repositories, services, logger, isStateful = false, tweaks = {}) {
        this.uiFrameAdapter = uiFrameAdapter;
        this.http = http;
        this.repositories = repositories;
        this.services = services;
        this.logger = logger;
        this.isStateful = isStateful;
        this.tweaks = tweaks;
        this.localStorage = new WindowLocalStorage(logger);
    }
    static create(uiFrameAdapter, http, logger, isStateful = false, tweaks = {}) {
        return new ServiceFactory(uiFrameAdapter, http, new Repositories(), new Services(), logger, isStateful, tweaks);
    }
    /** @internal */
    static createForTest(uiFrameAdapter, logger, repositories, isStateful = false) {
        return new ServiceFactory(uiFrameAdapter, new MockHttpClient(), repositories, new Services(), logger, isStateful);
    }
    get companyKeyRepository() {
        return this.repositories.companyKey || (this.repositories.companyKey = new HttpCompanyKeyRepository(this.http, this.localStorage, this.uiFrameAdapter, this.logger));
    }
    get deviceVaultRepository() {
        return this.repositories.device || (this.repositories.device = new HttpDeviceVaultRepository(this.http, this.logger));
    }
    get deviceGroupVaultRepository() {
        return this.repositories.deviceGroup || (this.repositories.deviceGroup = new HttpDeviceGroupVaultRepository(this.http, this.localStorage, this.logger));
    }
    get deviceGroupPolicyVaultRepository() {
        return this.repositories.deviceGroupPolicy || (this.repositories.deviceGroupPolicy = new HttpDeviceGroupPolicyVaultRepository(this.http, this.localStorage, this.logger));
    }
    get vaultRepository() {
        return this.repositories.vault || (this.repositories.vault = new HttpVaultRepository(this.http, this.localStorage, this.logger));
    }
    get vaultRequestRepository() {
        return this.repositories.vaultRequest || (this.repositories.vaultRequest = new HttpVaultRequestRepository(this.http, this.logger));
    }
    get userKeyRepository() {
        return this.repositories.userKey || (this.repositories.userKey = new HttpUserKeyRepository(this.http, this.localStorage, this.logger));
    }
    get cryptoService() {
        return this.services.cryptoService
            || (this.services.cryptoService = new CryptoService());
    }
    get companyKeyService() {
        return this.services.companyKeyService
            || (this.services.companyKeyService = new CompanyKeyService(this.cryptoService, this.initializeService, this.uiFrameAdapter, this.vaultRepository, this.companyKeyRepository, this.logger));
    }
    get deviceService() {
        return this.services.deviceService
            || (this.services.deviceService = new DeviceService(this.cryptoService, this.deviceVaultRepository, this.uiFrameAdapter, this.logger, this.tweaks));
    }
    get deviceGroupService() {
        return this.services.deviceGroupService
            || (this.services.deviceGroupService = new DeviceGroupService(this.cryptoService, this.deviceGroupVaultRepository, this.logger));
    }
    get deviceGroupPolicyService() {
        return this.services.deviceGroupPolicyService
            || (this.services.deviceGroupPolicyService = new DeviceGroupPolicyService(this.cryptoService, this.deviceGroupPolicyVaultRepository, this.logger));
    }
    get keyService() {
        return this.services.keyService
            || (this.services.keyService = new KeyService(this.uiFrameAdapter, this.userKeyRepository, this.cryptoService, this.logger));
    }
    get initializeService() {
        return this.services.initializeService
            || (this.services.initializeService = new InitializeService(this.uiFrameAdapter, this.deviceGroupService, this.deviceGroupPolicyService, this.logger));
    }
    get keyVaultService() {
        return this.services.keyVaultService
            || (this.services.keyVaultService = new KeyVaultService(this.uiFrameAdapter, this.vaultRepository, this.logger));
    }
    get tokenService() {
        return this.services.tokenService
            || (this.services.tokenService = new HttpTokenService(this.http, this.logger));
    }
    get userKeyPromptService() {
        return this.services.userKeyPromptService
            || (this.services.userKeyPromptService = this.isStateful
                ? new StatefulUserKeyPromptService(this.uiFrameAdapter, this.userKeyRepository, this.keyVaultService, this.companyKeyService, this.cryptoService, this.vaultRequestRepository, this.logger, this.localStorage)
                : new UserKeyPromptService(this.uiFrameAdapter, this.userKeyRepository, this.keyVaultService, this.companyKeyService, this.cryptoService, this.vaultRequestRepository, this.logger, this.localStorage));
    }
}
